export function toDegrees(angleInRadians: number) {
  return angleInRadians * (180 / Math.PI)
}

export function toRadians(angleInDegrees: number) {
  return angleInDegrees * (Math.PI / 180)
}

export function averageAngle(arcStart: number, arcEnd: number) {
  if (arcStart <= arcEnd) {
    return normalizeAngle(arcStart + arcEnd) / 2
  }
  // Add 360 degrees in the case when the arcEnd is before the arcStart,
  // because we signify that the arc of the angle goes through 0 when arcEnd < arcStart
  return normalizeAngle(arcStart + arcEnd + 360) / 2
}

export function normalizeAngle(angle: number) {
  const mod = angle % 360

  return mod < 0 ? 360 + mod : mod
}

// I think this function return also incorect result
// althogh I am still researching how to fix it
export function isAngleInArc(angle: number, arcStart: number, arcEnd: number) {
  if (arcStart <= arcEnd) {
    return arcStart <= angle && angle <= arcEnd
  }

  // an angle is always less than 360 and bigger than 0 here something seems odd
  return (arcStart < angle && angle <= 360) || (angle < arcEnd && angle >= 0)
}

export function arcSize(arcStart: number, arcEnd: number) {
  return Math.abs(arcStart - arcEnd) % 360
}
